import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../components/router/router-tabbed-navigation';
import { CreateFundingTransferDrawer } from '../../../../../../features/funding/transfer/create-funding-transfer-drawer';
import { FundingTransfersTable } from '../../../../../../features/funding/transfer/funding-transfers-table';
import { getPageHead } from '../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/funding/transfer/_transfer/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.RollupFunding,
      label: 'Single Transfers',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.RollupFunding>,
  head: () => getPageHead('Transfers'),
  component: FundingTransferList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <CreateFundingTransferDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Transfer" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.RollupFunding}
    />
  );
}

function FundingTransferList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <FundingTransfersTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
